import { makeObservable, observable, flow, action } from "mobx";
import { toast } from "sonner";

import { api } from "@/lib/services";
import { ApiRoutes } from "@/lib/routes";

import {
  ComplianceConfigurationKeys,
  ComplianceConfigurationContentTypes,
} from "@/areas/compliance/constants/configurationKeys";

export default class SegregationOfDutiesStore {
  saving = false;
  error = null;

  constructor(parentStore) {
    makeObservable(this, {
      saving: observable,
      error: observable,
      save: flow,
      reset: action,
    });

    this.parentStore = parentStore;
  }

  reset() {
    this.error = null;
  }

  *save(values) {
    try {
      this.saving = true;
      this.error = null;
      const payload = {
        contentType: ComplianceConfigurationContentTypes.SegregationOfDuties,
        value: {
          preventResolverFromClosing: Boolean(values.preventResolverFromClosing),
          preventResolverFromReopening: Boolean(values.preventResolverFromReopening),
        },
        // ClientVisibilityLevel.Member = 3 — every authenticated user can read the SoD config so the
        // close/reopen buttons can be gated on the client side.
        clientVisibilityLevel: 3,
      };
      const response = yield api.put(
        ApiRoutes.forComplianceConfigurationByKey(ComplianceConfigurationKeys.SegregationOfDuties),
        payload
      );
      toast.success("Segregation of duties updated");
      yield this.parentStore.configurationStore.load();
      return { success: true, data: response.data };
    } catch (e) {
      this.error = e;
      toast.error("Failed to update segregation of duties", {
        description: "Unexpected error, please try again later.",
      });
      return { success: false, error: e };
    } finally {
      this.saving = false;
    }
  }
}
